import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookie from 'react-cookie';
import { get, isEmpty, find } from 'lodash';
import moment from 'moment';

import { BookingsRequestFlow } from '../../app-bookings-request/bookings-request-flow';
import { fetchBooking } from '../actions/booking';
import { fetchContractsSnapshot } from '../actions/contracts';
import { fetchEnvWeb } from '../actions/env';
import { StripeContextProvider } from '../../elements-stripe/context/StripeContext';
import { getStripePublicKey } from '../../../../lib/stripe_key_util';

class BookingRequestContainer extends Component {
  componentDidMount () {
    const {
      auth,
      dispatch,
      params,
      location,
      iosWebView,
      bookingId,
      accessToken,
      env
    } = this.props;
    const requestID = get(location, 'query.request', '');
    const requestLength = requestID.length;

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate.loaded' });
    }

    if (iosWebView || (18 < requestLength || params.hasOwnProperty('bookingID'))) {
      const bookingID = iosWebView ? bookingId : params.hasOwnProperty('bookingID') ? params.bookingID : requestID;
      const accessToken = iosWebView ? this.props.accessToken : auth.accessToken;

      dispatch(fetchBooking(bookingID, accessToken,));
      dispatch(fetchContractsSnapshot(bookingID, accessToken));
    }

    if (accessToken && isEmpty(env?.web)) {
      dispatch(fetchEnvWeb());
    }
  }

  componentDidUpdate (prevProps) {
    const hasFetched = get(this.props, 'listing.hasFetched', false);
    const prevHasFetched = get(prevProps, 'listing.hasFetched', false);
    if (!prevHasFetched && hasFetched) {
      const {
        dispatch
      } = this.props;
      const spaceType = get(this.props, 'listing.data.space_type_tag', '');
      dispatch(fetchEnvWeb(`?space_type=${spaceType}`));
    }
  }

  render () {
    const { isFetching, contract = {}, location, stripeKey } = this.props;
    const requestID = get(location, 'query.request', '');
    // fetch contract if coming from no auth
    const isFetchingContract = !!requestID && isEmpty(contract.data);

    return (
      <div>
        { isFetching || isFetchingContract
          ? null
          : <StripeContextProvider stripeKey={stripeKey}>
            <BookingsRequestFlow {...this.props} />
          </StripeContextProvider>
        }
      </div>
    );
  }
}

BookingRequestContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  booking: PropTypes.object.isRequired,
  contracts: PropTypes.object,
  params: PropTypes.shape({
    listingID: PropTypes.string.isRequired
  }),
  stripeKey: PropTypes.string.isRequired
};

function mapStateToProps (state) {
  const {
    auth,
    profile,
    booking,
    services,
    listing,
    contract,
    env
  } = state;
  // schedule will come from either booking or cookie
  let schedule = Cookie.load('booking_schedule');
  if (schedule) {
    const scheduleStartDate = get(schedule[0], 'start.date', null)
    const scheduleEndDate = get(schedule[0], 'end.date', null)
    if (!scheduleStartDate || !scheduleEndDate) {
      Cookie.remove('booking_schedule', { path: '/' })
      schedule = [{}]
    }
  }
  const attendeeTier = Cookie.load('booking_attendee_tier');
  const contracts = get(contract, 'data.contracts', []);
  const masterContract = find(contracts, { type: 'MASTER' }) || {};
  const spaceRentalContract = find(contracts, { type: 'SPACE_RENTAL' }) || {};
  const noAuthBooking = 'CONTRACT_GUEST_NO_AUTH' === masterContract.state || 'REQUEST_GUEST_NO_AUTH' === masterContract.state;
  const noAuthBookingStartTime = get(spaceRentalContract, 'meta.booking.schedule[0].start');
  const validNoAuthDate = noAuthBookingStartTime ? moment(`${noAuthBookingStartTime.date.y}-${noAuthBookingStartTime.date.m}-${noAuthBookingStartTime.date.d} ${noAuthBookingStartTime.time.h}:${noAuthBookingStartTime.time.m}`, 'YYYY-MM-DD HH:mm').isAfter() : false;
  const country = get(listing, 'data.country', '');
  const stripeKeys = get(env, 'web.stripe', {});
  const stripeKey = getStripePublicKey(country, stripeKeys);

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  return {
    listing,
    auth,
    profile,
    isFetching,
    schedule,
    booking,
    services,
    attendeeTier,
    contract,
    noAuthContracts: noAuthBooking ? contracts : [],
    noAuthBooking,
    validNoAuthDate,
    stripeKey,
    env
  };
}

export default connect(mapStateToProps)(BookingRequestContainer);
